<template>
    <div id="app">
        <div class="app-widget app-widget--center">
            <div class="app-widget__end">
                <h1>СПАСИБО, ВАША онлайн консультация успешно ПОДТВЕРЖДЕНА</h1>
                <div class="app-widget__list-wrap">
                    <ul class="app-widget__list">
                        <li class="app-widget__list-item">
                            Дата / Время
                        </li>
                        <li class="app-widget__list-item">
                            ФИО врача
                        </li>
                       <!-- <li class="app-widget__list-item">
                            Специальность врача
                        </li>-->
                    </ul>
                    <ul class="app-widget__list">
                        <li class="app-widget__list-item">
                            <strong>{{appointmentDate}}</strong>
                        </li>
                        <li class="app-widget__list-item">
                            <strong>{{doctorName}}</strong>
                        </li>
                        <li class="app-widget__list-item" v-if="false">
                            <strong>
                                <span v-for="(item, index) in doctorProfession"
                                      :key="item.name"
                                >{{ index === 0 ? item.name : ',' + item.name.replace('Врач','')}}</span>
                            </strong>
                        </li>
                    </ul>
                </div>
                <a href="/" class="button app-widget__end-btn">На главную</a>
                <a class="app-widget__end-link" href="/"><span>Политика в обработке персональных данных</span></a>
            </div>
        </div>
    </div>
</template>

<script>
  import UserService from '../services/api.service';
  import moment from 'moment';

  export default {
    name: 'approved',
    data() {
      return {
        doctorName: null,
        doctorProfession: [],
        appointmentDate: null
      }
    },
    methods: {
      formatDate(appointmentData) {
        const date = moment(appointmentData).format('DD.MM.YYYY');
        const time = moment(appointmentData).format('HH:mm');
        this.$nextTick(() => {
          this.appointmentDate = `${date} в ${time}`;
        });
      },
    },
    beforeCreate() {

      UserService.getApprovedPatient(this.$route.params.id)
          .then(res => {
            this.$nextTick(() => {
              this.doctorName = res.data.doctor.name;
              this.doctorProfession = res.data.doctor.positions;
            });
            this.formatDate(res.data.date);
            if(window.createRecordCallback) {
              window.createRecordCallback(res.data);
            }
          })
          .catch(err => {
            console.log(err)
          });
    },
    created() {

    }
  }
</script>

<style lang="sass">
.app-widget
    &--center
        display: flex
        align-items: center
        justify-content: center
    &__end
        position: relative
        max-width: 650px
        background: #FFFFFF
        box-shadow: 0 8px 70px rgba(0, 0, 0, 0.03)
        padding: 50px 62px 45px

        @media all and (max-width: 513px)
            padding: 30px

        h1
            font-size: 24px
            text-transform: uppercase
            margin: 0 0 80px

            @media all and (max-width: 513px)
                margin: 0 0 40px

        .app-widget__list-wrap
            margin: 0 0 40px

        &-container
            display: flex
            flex-wrap: wrap
            margin: 30px 0 0

            @media all and (max-width: 513px)
                flex-direction: column
                .button
                    &:first-child
                        margin: 0 0 15px

        @media all and (max-width: 513px)
            .button
                max-width: 100%
                height: 48px!important

        &-link
            font-size: 14px
            line-height: 15px
            text-align: center
            color: #A9A9A9
            position: absolute
            text-decoration: unset
            bottom: -40px
            left: 0
            right: 0
            margin: 0 auto

            span
                border-bottom: 1px solid #A9A9A9


        &-btn
            border: 1px solid #1BB3B2!important
            background-color: #fff!important
            color: #222!important
            max-width: 180px
            width: 100%
            text-transform: capitalize!important
            font-size: 14px!important
            margin-right: 15px

            &:hover
                background-color: #1BB3B2!important
                color: #fff!important

</style>
